import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api, { Place } from '../lib/api'

export default function PlacesPage() {
  const [items, setItems] = useState<Place[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [q, setQ] = useState('')

  const load = async (query?: string) => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.places.list({ q: query || undefined })
      setItems(res.data)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to load places')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Places</h1>
        <Link to="/places/new" className="px-3 py-2 rounded bg-blue-700 text-white text-sm">New Place</Link>
      </div>

      <form
        className="flex gap-2"
        onSubmit={(e) => {
          e.preventDefault()
          void load(q)
        }}
      >
        <input className="border rounded px-3 py-2 text-sm w-full" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search places..." />
        <button className="border rounded px-3 py-2 text-sm">Search</button>
      </form>

      {error && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 rounded text-sm">{error}</div>}
      {loading ? <div className="text-sm text-gray-500">Loading places...</div> : null}

      {!loading && !items.length ? <div className="text-sm text-gray-500">No places found.</div> : null}

      <div className="bg-white border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-3 py-2">Type</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">City</th>
              <th className="px-3 py-2">State</th>
              <th className="px-3 py-2">ZIP</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t">
                <td className="px-3 py-2">{p.placeType ?? 'OTHER'}</td>
                <td className="px-3 py-2"><Link className="text-blue-700" to={`/places/${p.id}`}>{p.name ?? 'Unnamed'}</Link></td>
                <td className="px-3 py-2">{p.city ?? '-'}</td>
                <td className="px-3 py-2">{p.state ?? '-'}</td>
                <td className="px-3 py-2">{p.zip ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
